<template lang="pug">
  .footer
    .container
      .footer__wrapper
        h4 SAP CX DAY 事務局
        p E-mail：<a href="mailto:SAPCX@eventdesk.jp">SAPCX@eventdesk.jp</a> <span>受付時間：10:00〜17:00（土日・祝日を除く）</span>
        p
          paramlink(
            title="SAPプライバシーステートメント"
            url="https://www.sap.com/japan/about/legal/privacy.html"
            target="_blank")

</template>

<script>
import Paramlink from "@/components/Paramlink.vue";

export default {
  components: {
    Paramlink
  }
};
</script>


<style lang="scss" scoped>
@import "./src/assets/scss/_variables.scss";
.footer {
  .container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 16px;
  }

  &__wrapper {
    padding: 20px 0;

    a {
      color: $link-color;
      text-decoration: none;
    }

    ul {
      list-style: none;
      padding: 0;
    }

    li {
      text-indent: -1em;
      margin-left: 1em;
      font-size: .9rem;
    }

    h4 {
      margin-top: 20px;
      margin-bottom: 0;
    }

    h4 + p {
      margin-top: 0;
    }

    h4 + p span {
      display: block;
    }

    p + p {
      margin-top: 40px;

      a {
        font-size: .9rem;
      }
    }
  }
  @media screen and (min-width: 769px) {
    h4 + p span {
      display: inline-block;
    }

    h4 + p span::before {
      display: inline-block;
      content: "/";
      margin: 0 .5em;
    }
  }

}
</style>